import React from 'react';
import { Table } from 'antd';
import './TableSkeleton.css';

const SkeletonCell = ({ width }) => (
  <div className="skeleton-cell" style={{ width }} />
);

const TableSkeleton = () => {
  const months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
  
  const columns = [
    {
      title: <SkeletonCell width={60} />,
      dataIndex: 'cod',
      width: 90,
    },
    {
      title: <SkeletonCell width={200} />,
      dataIndex: 'name',
      width: 300,
    },
    ...months.map((_, index) => ({
      title: <SkeletonCell width={50} />,
      dataIndex: `month${index}`,
      width: 80,
    })),
  ];

  const data = [...Array(10)].map((_, index) => ({
    key: index,
    cod: <SkeletonCell width={60} />,
    name: <SkeletonCell width={200} />,
    ...months.reduce((acc, _, monthIndex) => ({
      ...acc,
      [`month${monthIndex}`]: <SkeletonCell width={50} />,
    }), {}),
  }));

  return (
    <div className="table-clabs">
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        bordered
        size="small"
        scroll={{ x: '1350px', y: `${window.innerHeight - 175}px` }}
      />
    </div>
  );
};

export default TableSkeleton; 